import clsx from 'clsx';
import Image from 'next/image';

import plusBadge from '~/public/plus-badge-tag.png';

export function PlusBadge({ className }: { className?: string }) {
  return (
    <UserBadge theme="plus" className={className}>
      <Image
        src={plusBadge}
        alt="Plus member"
        height={80}
        width={280}
        className="h-2 w-fit"
      />
    </UserBadge>
  );
}

export function SumoBadge({ className }: { className?: string }) {
  return (
    <UserBadge theme="sumo" className={className}>
      SUMO
    </UserBadge>
  );
}

export default function UserBadge({
  theme,
  className,
  children,
}: {
  theme: 'plus' | 'sumo';
  className?: string;
  children?: React.ReactNode;
}) {
  return (
    <div
      className={clsx(
        className,
        'h-fit w-fit rounded border-[0.5px] border-solid p-1 font-badge',
        { 'border-money-moss text-money-moss': theme === 'sumo' },
        { 'border-ready-red text-ready-red': theme === 'plus' },
      )}
      style={{ lineHeight: '8px', fontSize: '11px' }}
      data-testid="user-badge"
    >
      {children}
    </div>
  );
}
